module.exports = __webpack_public_path__ + "img/0Q3A4053_L_Foamcore_MockedUp.a9817189.jpg";